import { createSelector } from 'reselect';
import * as selectors from 'selectors/selectors';

export const projectPermissionsSelector = createSelector(
  state => selectors.currProjectSelector(state),
  project => project.permissions
);
